import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnrollmentModule, PhoneEnrollmentEnvironment } from '@krediya/enrollment';
import { environment } from 'projects/store/src/environments/environment';
import { GeneralModule } from '../general/general.module';
import { SalesPhoneEnrollmentLibraryComponent } from './sales-phone-enrollment-library.component';

@NgModule({
  declarations: [
    SalesPhoneEnrollmentLibraryComponent
  ],
  imports: [
    CommonModule,
    GeneralModule,
    EnrollmentModule.forRoot({
      environment: environment.enrollmentEnvironment as PhoneEnrollmentEnvironment,
      production: environment.production
    })
  ],
  exports: [
    SalesPhoneEnrollmentLibraryComponent
  ]
})
export class SalesPhoneEnrollmentLibraryModule {}
